/* eslint-disable @typescript-eslint/no-explicit-any */
import { Star } from "@/components/icons";
import { WhyChooseUsSkeleton } from "./components/loader";
import Link from "next/link";
import { TROPHY_CLUB_GOOGLE_REVIEWS_URL } from "@/lib/constants";

const WhyChooseUs = ({ isLoading }: { isLoading: boolean }) => {
  if (isLoading) return <WhyChooseUsSkeleton />;
  return (
    <div className="bg-slate-50">
      <div className="container py-12 lg:py-32">
        <div className="flex flex-col items-center justify-between gap-4 lg:gap-8">
          <h2 className="text-primary text-center text-3xl font-semibold lg:text-7xl">
            Why{" "}
            <span className="font-vollkorn font-normal italic">
              our users Recommend Us
            </span>{" "}
          </h2>
          <div className="flex flex-col gap-1.5 lg:gap-3">
            <div className="flex items-center">
              {[1, 2, 3, 4, 5].fill(5).map((_, index) => (
                <Star
                  key={index}
                  className="size-6 text-[#FFBB00] lg:size-12"
                />
              ))}
              <Link
                href={TROPHY_CLUB_GOOGLE_REVIEWS_URL}
                target="_blank"
                className="ml-3 text-xl font-bold text-blue-600 underline underline-offset-8 lg:text-5xl"
              >
                (3k+)
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
